import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from "jalali-moment";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";


////components
import LogOut from "../../redux/featuer/user/userSlice";
import PageChange from "../../pageChange/index";
import Search from "../../component/search";
import Layout from "../../component/Layout/Layout";
import Card from "../../component/Layout/theme/card/index";



//
//
import { RxDoubleArrowLeft, RxDoubleArrowRight } from "react-icons/rx";
import toast from "react-hot-toast";

function OrderPage() {

    var limitPage = 5;
    var pagination = 1;
    const [paginationSelected, setPaginationSelected] = useState(1);
    const [loadPage, setLoadPage] = useState(0)
    const navigate = useNavigate()
    var { t } = useTranslation()
    /////
    const [isDataLoad, setIsDataLoad] = useState(false);


    //برای لود شدن جدول ها
    const [data, setData] = useState([])


    ////token
    const { token, login } = useSelector((item) => item.user)


    useEffect(() => {
        document.title = t("oreders");
        if (login === true) {
            getOrder(limitPage, pagination)
        }
    }, [])


    async function getOrder(limit, page) {
        // توکن ب سرور داده شده و اطلاعات کاربر دریافت
        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/all/${limit}/${page}`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error(t("you_not_access"));
                        window.location.href = 'login';
                    }
                    if (result.status === "success") {
                        setLoadPage(parseInt(result.pages))

                        setIsDataLoad(true)
                        setData(result.data)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = 'login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }


    //preview table page button
    function actionPreviewPagination() {
        getOrder(limitPage, paginationSelected - 1);
        setPaginationSelected(paginationSelected - 1);
        setIsDataLoad(false)
    }

    //next table page button
    function actionNextPagination() {
        getOrder(limitPage, paginationSelected + 1);
        setPaginationSelected(paginationSelected + 1);
        setIsDataLoad(false)

    }

    const payment = (id) => {
        window.location.href = `${process.env.REACT_APP_SERVER}/api/payment/${id}?authorization=${token}`;
    }


    return (
        <>
            {isDataLoad ? (
                <>
                    <Layout />
                    <div className="px-6 mx-auto mb-3 max-w-screen-2xl sm:px-8 lg:px-16">

                        <Search propsData={`${process.env.REACT_APP_SERVER}/api/nft/file`} />
                    </div>


                    <Card >
                        <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                            <h5 className="text-xl leading-none text-center text-gray-900">
                                {t("orders")}
                            </h5>

                            {
                                data.map((item, index) => {
                                    const url = item.url;
                                    const UserName = item.user.username;
                                    return (
                                        <>

                                            <div
                                                key={index}
                                                className="flex flex-col items-center gap-5 px-3 py-2 rounded-md cursor-pointer md:gap-0 md:flex-row md:items-center md:justify-between md:space-y-8 hover:bg-gray-50 hover:shadow-md">

                                                <div className="flex items-center "
                                                    onClick={() => {
                                                        // `/qrcode/${item._id}`
                                                        navigate(`/qrcode/${item._id}`);
                                                    }}>
                                                    {/* qrcode */}
                                                    <div className="">
                                                        <QRCode
                                                            size={250}
                                                            style={{ height: "auto", width: "50px", }}
                                                            value={`${process.env.REACT_APP_CLIENT}/view/${UserName}/${url}`}
                                                            viewBox={`0 0 256 256`}
                                                            id="qr-payment"
                                                        />
                                                    </div>

                                                </div>

                                                {/* date */}
                                                <div className="flex flex-col items-center">
                                                    <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                                                        {item.name}
                                                    </p>
                                                    <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                                                        {moment(new Date(parseInt(item.create_in))).format(
                                                            "jYYYY/jMM/jDD"
                                                        )}
                                                    </p>

                                                </div>
                                                {/* button  */}
                                                <div className="text-sm ">

                                                    {item.statusPayment === true ? (
                                                        <button
                                                            type="button"
                                                            className="w-full px-2 py-2 text-white bg-green-500 rounded-xl"
                                                        >
                                                            {t("Paid")}
                                                        </button>
                                                    ) : (
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="relative w-full px-2 py-2 text-white bg-red-500 rounded-xl"
                                                                onClick={() => payment(item._id)}
                                                            >
                                                                {t("Repayment")}
                                                            </button>

                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                            <hr className="mt-2 mb-2 md:hidden" />
                                        </>
                                    )
                                })}
                            <div className="flex items-center justify-center gap-5">
                                {
                                    paginationSelected === loadPage ? <div /> :

                                        <RxDoubleArrowRight size={20} className="cursor-pointer" onClick={() => actionNextPagination()} />
                                }
                                {
                                    Array(loadPage).fill(null).map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <h1 className={paginationSelected === index + 1 ? "text-red-600" : "text-gray-400"}>{index + 1}</h1>
                                            </div>
                                        )

                                    }).reverse()
                                }
                                {
                                    paginationSelected === 1 ? <div />

                                        :
                                        <RxDoubleArrowLeft size={20} className="cursor-pointer" onClick={() => actionPreviewPagination()} />
                                }
                            </div>
                        </div>
                    </Card>

                </>
            ) : (
                <PageChange />
            )
            }
        </>
    )



}

export default OrderPage;
